// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import jssdk from "weixin-js-sdk"
import vueEsign from 'vue-esign'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';

window.axios = axios
Vue.use(VueAxios, axios)
Vue.config.productionTip = false;
Vue.prototype.$wx = jssdk;
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'];
Vue.use(vueEsign);
Vue.use(Element, { size: 'small', zIndex: 2000 });
Vue.use(Vant);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js